import { MARQUEE_ITEMS } from "./data";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative py-6 border-y hairline overflow-hidden"
      style={{ background: "var(--marquee-bg)" }}
    >
      <div className="flex w-max marquee-track">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-mono text-sm tracking-[0.25em] uppercase txt-soft px-8">
              {item}
            </span>
            <span className="text-purple-500">✦</span>
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32" style={{ background: "linear-gradient(to right, var(--bg), transparent)" }} />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32" style={{ background: "linear-gradient(to left, var(--bg), transparent)" }} />
    </section>
  );
};
